export const JSON_EDITOR_OPTIONS = {
  baseUrl: 'kql-builder',
  theme: 'vs',
  language: 'json',
  minimap: {
    enabled: false
  },
  lineNumbers: 'off',
  scrollBeyondLastLine: false,
  automaticLayout: true
};
